import React, { useState, useEffect, useRef, Component } from 'react';

function Support() {
  useEffect(() => {}, []);

  var someLink = (
    <a href="http://localhost:3000/policy-cookie">Cookies Policy</a>
  );
  return (
    <div className="privacy-policy-container">
      <h2>Twist Support</h2>
      <p>
        For any questions, concerns and even suggestions concerning Twist,
        please contact us at:
      </p>
      <h2>twistedapp@hotmail.com</h2>
    </div>
  );
}

export default Support;
